import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

const BEFORE_FILTER = "grayscale(0.75) brightness(0.72) sepia(0.35) contrast(0.9)";

const BeforeAfter = ({ image, title, subtitle }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const move = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    const x = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(94, Math.max(6, x)));
  };

  return (
    <div className="group" data-testid={`before-after-${title}`}>
      <div
        ref={ref}
        className="relative aspect-[4/3] cursor-ew-resize touch-none select-none overflow-hidden rounded-3xl shadow-lg"
        onPointerDown={(e) => {
          e.currentTarget.setPointerCapture(e.pointerId);
          move(e.clientX);
        }}
        onPointerMove={(e) => {
          if (e.buttons === 1) move(e.clientX);
        }}
        role="slider"
        aria-label={`Comparador antes y después de ${title}`}
        aria-valuenow={Math.round(pos)}
        aria-valuemin={0}
        aria-valuemax={100}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "ArrowLeft") setPos((p) => Math.max(6, p - 5));
          if (e.key === "ArrowRight") setPos((p) => Math.min(94, p + 5));
        }}
      >
        <img
          src={image}
          alt={`Después de la limpieza - ${title}`}
          className="absolute inset-0 h-full w-full object-cover"
          draggable={false}
          loading="lazy"
        />
        <img
          src={image}
          alt={`Antes de la limpieza - ${title}`}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ filter: BEFORE_FILTER, clipPath: `inset(0 ${100 - pos}% 0 0)` }}
          draggable={false}
          loading="lazy"
        />
        <span className="absolute left-4 top-4 rounded-full bg-slate-900/80 px-3 py-1 text-xs font-bold uppercase tracking-widest text-white backdrop-blur">
          Antes
        </span>
        <span className="absolute right-4 top-4 rounded-full bg-brand px-3 py-1 text-xs font-bold uppercase tracking-widest text-white">
          Después
        </span>
        <div
          className="absolute inset-y-0 z-10 w-1 bg-white shadow-[0_0_12px_rgba(0,0,0,0.4)]"
          style={{ left: `${pos}%` }}
        >
          <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-slate-700 shadow-xl transition-transform group-hover:scale-110">
            <ChevronsLeftRight size={20} />
          </span>
        </div>
      </div>
      <p className="mt-4 font-display text-base font-bold text-slate-900">{title}</p>
      <p className="text-sm text-slate-500">{subtitle}</p>
    </div>
  );
};

export default BeforeAfter;
